import { MouseEvent, ReactNode } from 'react';
import Flex from '@deprecated-ui/common/Flex';
import Text from '@deprecated-ui/common/Text';
import colorConstants from '@deprecated-ui/_style/color';
import Icon from '@ant-design/icons';
import { formatNumber } from 'utils/number';
import InfoSvg from 'global/Securities/components/Icons/InfoSvg';
import If from 'global/ErrorHandlers/If';
import { InfoButton } from 'global/Securities/components/Form/TransactionForm/OrderTypeFormItem/styled';
import {
  formatBondCurrency,
  formatPricePercentage,
} from 'features/securities/withdrawal/utils';
import { FormItemShimmer } from './ModalBondsBuy/styled';
import { FormItem } from '../styled';

interface Props {
  isLoading?: boolean;
  isBold?: boolean;
  isNeedInfo?: boolean;
  label?: ReactNode;
  type?: 'default' | 'currency' | 'pl' | 'percentage' | 'number' | 'unit';
  value?: number;
  isShowSign?: boolean;
  onInfoClick?(): void;
  isDisabled?: boolean;
  subtitle?: string;
  defaultColor?: string;
  plPercentage?: number;
}

export default function FormDisplayField({
  label = '-',
  isLoading = false,
  value = 0,
  isBold = false,
  type = 'default',
  isNeedInfo = false,
  onInfoClick = () => {},
  isShowSign = false,
  isDisabled = false,
  subtitle = '',
  defaultColor = '#333333',
  plPercentage = undefined,
}: Props) {
  let color = defaultColor;
  let sign = '';

  if (type === 'pl') {
    color = value >= 0 ? colorConstants.primary : colorConstants.sunsetOrange;
  }
  if (isShowSign || type === 'pl') {
    sign = value > 0 && value !== 0 ? '+' : '-';
  }

  const handleInfoClick = (e: MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    onInfoClick();
  };

  const composed =
    `${sign}Rp${formatNumber(Math.abs(value), true, '0,0.00')}` +
    ` (${sign}${formatNumber(Math.abs(plPercentage), true, '0,0.00', true)}%)`;

  const isMultiline = composed.length >= 22;

  return (
    <FormItem
      disabled={isDisabled}
      label={
        <div>
          <Flex align="center">
            <span>{label}</span>
            <If condition={isNeedInfo}>
              <InfoButton type="button" onClick={handleInfoClick}>
                <Icon
                  component={InfoSvg}
                  style={{ fontSize: 16, color: '#969696', marginLeft: 4 }}
                />
              </InfoButton>
            </If>
          </Flex>
          <If condition={subtitle}>
            <Text size="12px" color="#B5B5B5" align="right">
              {subtitle}
            </Text>
          </If>
        </div>
      }
    >
      {isLoading ? (
        <FormItemShimmer />
      ) : (
        <>
          <If condition={type === 'pl' && isMultiline}>
            <Flex direction="column" align="start">
              <Text color={color} family={isBold ? 'bold' : 'normal'}>
                {formatBondCurrency(value, 'exceptZero')}
              </Text>
              <If condition={plPercentage !== undefined}>
                <Text
                  color={color}
                  family={isBold ? 'bold' : 'normal'}
                  align="end"
                >
                  {' '}
                  ({formatPricePercentage(plPercentage, 'exceptZero')})
                </Text>
              </If>
            </Flex>
          </If>

          <If condition={type === 'pl' && !isMultiline}>
            <Text color={color} family={isBold ? 'bold' : 'normal'}>
              {formatBondCurrency(value, 'exceptZero')}
              <If condition={plPercentage !== undefined}>
                {' '}
                ({formatPricePercentage(plPercentage, 'exceptZero')})
              </If>
            </Text>
          </If>

          <If condition={type !== 'pl'}>
            <Text family={isBold ? 'bold' : 'normal'} color={color} size="14px">
              <If condition={type === 'currency'}>
                {formatBondCurrency(value, isShowSign ? 'exceptZero' : 'never')}
              </If>
              <If condition={type === 'percentage'}>
                {formatPricePercentage(
                  value,
                  isShowSign ? 'exceptZero' : 'never',
                )}
              </If>
              <If condition={type === 'number'}>
                {isShowSign ? sign : ''}
                {formatNumber(value, true, '0,0.00')}
              </If>
              <If condition={type === 'unit'}>{value} Unit</If>
              <If condition={type === 'default'}>{value}</If>
            </Text>
          </If>
        </>
      )}
    </FormItem>
  );
}
